<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../../services/i18n';
	import { postReq } from '../../../../../services/http';
	//Stores
	//Helpers
	import { onSettingsResponse } from '../../../../../helpers/device_settings_helpers';
	//Types
	import type { Device } from '../../../../../types/Device';
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	import type { InputClickEvent } from '../../../../../types/InputClickEvent';
	//Design system components
	import { Toggle, Alert } from '@Shelly/shelly-design-system';
	export let device: Device;

	const settings = readDeviceSettings(device.id);
	let protection = settings.child_lock;
	let cacheProtection = protection;
	let loading = false;

	const sendRequest = async (e: InputClickEvent): Promise<void> => {
		loading = true;
		protection = e.target.checked;
		const res: SettingRequest = await postReq(
			`device/generic_command`,
			{
				id: device.id,
				command: 'child_lock',
				payload: JSON.stringify({ enabled: protection }),
			},
			20000,
		);

		if (!res?.isok) {
			protection = !protection;
		}

		onSettingsResponse(res, device);
		loading = false;
		cacheProtection = protection;
	};
</script>

<Toggle
	size="m"
	class="mb-s"
	disabled={loading}
	checked={protection}
	on:click={sendRequest}
	id="toggle-g3tacuv"
>
	{$format('enable_kids_protection', {
		default: 'Enable kids protection.',
	})}
</Toggle>

<Alert
	heading={$format('kids_protect_desctription', {
		default: 'If enabled, hold 2 buttons for 5 seconds to activate display',
	})}
/>
